<div class="row" style="width:100%; float: right; text-align: right; margin-top: 0px; padding-top: 0px; margin-right:0px !important"><div class="col-11"></div><div class="col-1 text-right" style="float:right; margin-right:0px; padding-right:0px;"><mat-icon style="float:right; cursor: pointer;" (click) = "onNoClick()">cancel</mat-icon></div></div>
<h1 mat-dialog-title>{{labels.lblAddNewSector}}</h1>
<div mat-dialog-content>
  <form (ngSubmit)="onSubmit()" #insertForm="ngForm">
    <div fxLayout="column">
      <input type="hidden" name = "adminId" [ngModel] = "admin.id">
      <mat-form-field appearance="none" fxFlex="60%">
        <mat-label>{{labels.lblSectorName}}</mat-label>
        <input matInput ngModel name="name" #name="ngModel" required>
        @if (nameErr == true) {
          <mat-error style="margin-bottom:1.5vh !important;">{{labels.lblfieldRequired}}</mat-error>
        }
      </mat-form-field>
      <!--<mat-form-field appearance="none" fxFlex="60%">
        <mat-label>E-mail</mat-label>
        <input matInput ngModel name="email" #email="ngModel" required>
        @if (emailErr == true) {
          <mat-error style="margin-bottom:1.5vh !important;">{{labels.lblfieldRequired}}</mat-error>
        }
      </mat-form-field>-->
      <mat-form-field appearance="none" >
        <mat-label>{{labels.lblParentSector}}</mat-label>
        <mat-select  ngModel name="parentId" class="matSelect">
          @for (department of departments; track department) {
            <mat-option [value]="department.id">
              {{department.name}}
            </mat-option>
          }
          @if (admin.headAdmin) {
            <mat-option [value]="''">
              /
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
      <!-- <mat-form-field appearance="none">
      <mat-label>{{labels.lblAdministrator}}</mat-label>
      <mat-select ngModel name="adminId" class="matSelect" required>
        <mat-option *ngFor="let admin of administrators" [value]="admin.id">
          {{admin.firstName}} {{admin.lastName}}
        </mat-option>
      </mat-select>
      <mat-error *ngIf="emailErr == true" style="margin-bottom:1.5vh !important;">{{labels.lblfieldRequired}}</mat-error>
    </mat-form-field> -->

    <div mat-dialog-actions>
      <!-- <button class="noBtn" mat-button (click)="onNoClick()" type="button">{{labels.lblNo}}</button> -->
      <button class="btn" cdkFocusInitial type="submit">{{labels.lblAdd}}</button>
    </div>
  </div>
</form>

</div>



